module.exports = __webpack_public_path__ + "static/media/alec.2d9e138a.jpg";